import { Label } from 'components/atoms';
import { useFormikContext } from 'formik';
import { isBoolean } from 'lodash';
import React from 'react';
import { PiX } from 'react-icons/pi';
import { objectToArray } from 'utils/global/object.utils';
import './QueryFilterLabels.scss';

interface IQueryFilterLabelsProps {
  isFormOpen?: boolean;
  customLabel?: (data: { key: string; value: unknown }) => React.ReactNode;
}

const QueryFilterLabels = <T extends {}>({
  isFormOpen = false,
  customLabel,
}: IQueryFilterLabelsProps) => {
  const { values, setValues } = useFormikContext<T>();

  const labels = objectToArray<T>(values).filter(data =>
    isBoolean(data.value) ? data.value !== undefined : !!data.value
  );

  const removeFilter = (key: string) => {
    setValues(prev => ({ ...prev, [key]: '' }));
  };

  const visibleLabels = labels
    .map(data => ({
      key: data.key,
      content: customLabel
        ? customLabel(data)
        : data.value
        ? `${data.value}`
        : '',
    }))
    .filter(
      label => label.content !== undefined && label.content !== null && label.content !== ''
    );

  return !visibleLabels.length || isFormOpen ? null : (
    <div className='query-filter-labels-wrapper'>
      <div className='query-filter-labels'>
        {visibleLabels.map(label => (
          <Label
            key={label.key}
            size='compact'
            className='query-filter-label'
            onClick={() => removeFilter(label.key)}>
            <PiX />
            <div className='label-text'>{label.content}</div>
          </Label>
        ))}
      </div>
    </div>
  );
};

export default QueryFilterLabels;
